<template>
  <div>
    <div class="d-flex align-items-end justify-content-end">
      <div class="d-inline-block mb-4 mt-2">
        <button v-b-modal.modalAddGroup
                class="btn btn-sm btn-primary"
                type="button">
          Adicionar
        </button>
      </div>
    </div>

    <div v-if="groups.length"
         class="responsive-table">
      <b-table class="mb-2 acessGroupTable"
               sticky-header
               thead-class="thead--green"
               bordered
               hover
               :items="filterGroups"
               :fields="fields"
               :small="true">
        <template slot="ativo"
                  slot-scope="data">
          <span class="custom-control custom-switch mb-2">
            <input :id="`interditado-${data.item.group_id}`"
                   class="custom-control-input"
                   :name="`interditado-${data.item.group_id}`"
                   type="checkbox"
                   :checked="(data.item.ativo === 1)"
                   @change="activeOrInactiveGroup(data.item)">
            <label class="custom-control-label"
                   :for="`interditado-${data.item.group_id}`">Ativo</label>
          </span>
        </template>

        <template slot="nome"
                  slot-scope="data">
          <span class="text-capitalize">{{ data.item.name }}</span>
        </template>

        <template slot="actions"
                  slot-scope="data">
          <div class="d-block text-center">
            <button class="btn btn--xs btn-primary mr-2"
                    title="Editar grupo de acesso"
                    type="button"
                    @click="openEditGroup(data.item)">
              <svg class="icon icon--xxs icon--clearFill"
                   role="presentation">
                <use :xlink:href="'#' + edit.id" />
              </svg>
            </button>

            <button class="btn btn--xs btn-danger"
                    title="Deletar grupo de acesso"
                    type="button"
                    @click="deleteGroup(data.item)">
              <svg class="icon icon--xxs icon--clearFill"
                   role="presentation">
                <use :xlink:href="'#' + trash.id" />
              </svg>
            </button>
          </div>
        </template>
      </b-table>
    </div>

    <p v-else
       class="text--return border border-primary text-center rounded m-2 py-4">
      Nenhum Grupo cadastrado.
    </p>

    <b-modal id="modalAddGroup"
             ref="modalAddGroup"
             modal-class="customModal"
             body-class="customModal_body"
             hide-header
             title-class="customModal_header_title"
             footer-class="customModal_footer"
             title="Grupos de usuário"
             size="xl"
             @hidden="clearEdit">
      <div>
        <form class="mb-2"
              novalidate>
          <div class="row">
            <div class="col-12 col-sm-6 col-md-5">
              <div class="form-group">
                <label class="label"
                       for="nomeDoGrupo"> Nome do Grupo</label>
                <input id="nomeDoGrupo"
                       v-model="nomeDoGrupo"
                       class="form-control form-control-sm"
                       name="nomeDoGrupo"
                       placeholder="Caixa"
                       type="text">
              </div>
            </div>
          </div>
        </form>

        <div v-if="permissions.length"
             class="">
          <b-tabs v-model="tabIndex"
                  content-class="mt-3"
                  nav-class="customNavModal"
                  align="left"
                  active-nav-item-class="tabModalActive"
                  no-body>
            <b-tab active
                   title-item-class="customNavModal_link"
                   title="Sofia-REI">
              <h4 class="headerTitle mb-4">
                Permissões
              </h4>

              <div class="row mt-2">
                <div v-if="filterReiPermissions.length"
                     class="col-12 col-lg-4 col-sm-6">
                  <span class="custom-control custom-switch mb-2">
                    <input id="todasPermissoesRei"
                           v-model="todasPermissoesRei"
                           class="custom-control-input"
                           name="todasPermissoesRei"
                           type="checkbox"
                           :value="true">
                    <label class="custom-control-label"
                           for="todasPermissoesRei">Todas</label>
                  </span>
                </div>
                <div v-for="(val, ind) in filterReiPermissions"
                     :key="ind"
                     class="col-12 col-lg-4 col-sm-6">
                  <span class="custom-control custom-switch mb-2">
                    <input :id="`permissionRei-${val.codename}-${ind}`"
                           v-model="listPermissions"
                           class="custom-control-input"
                           :name="`permission-${val.codename}-${ind}`"
                           type="checkbox"
                           :value="val.permission_id">
                    <label class="custom-control-label"
                           :for="`permissionRei-${val.codename}-${ind}`">{{ val.nome }}</label>
                  </span>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>

        <p v-else
           class="text--return border border-primary text-center rounded m-2 py-4">
          Nenhuma permissão cadastrada
        </p>
      </div>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <div class="row no-gutters justify-content-end align-items-center">
          <button class="btn btn-sm btn-dark mr-2"
                  @click="cancel()">
            Voltar
          </button>
          <button class="btn btn-sm btn-primary"
                  :disabled="!listPermissions.length || !nomeDoGrupo"
                  type="button"
                  @click="addOrEditGroup">
            {{ Object.keys(editObj).length ? 'Editar' : 'Adicionar' }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import trash from '@/assets/icons/delete.svg?sprite'
  import edit from '@/assets/icons/pencil.svg?sprite'
  import objSwal from '@/constants/swalValues'
  import Swal from 'sweetalert2'

  /* services */
  import AccessGroupsService from '@/services/Auth/AccessGroupsService'

  /* outros */
  import {mapGetters} from "vuex"

  export default {
    name: 'ServentiaAcessGroups',
    props: {
      propWizard: {type: Boolean, default: false}
    },
    data () {
      return {
        trash,
        edit,
        tabIndex: 0,
        edicao: false,
        nomeDoGrupo: '',
        editObj: {},
        todasPermissoesRei: false,
        listPermissions: [],
        groups: [],
        permissions: [],
        fields: [{
          key: 'ativo',
          label: 'Ativo',
          sortable: true
        }, {
          key: 'nome',
          label: 'Grupo',
          sortable: true
        }, {
          key: 'actions',
          label: '',
          sortable: false
        }],
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
        token: 'auth/getUserToken'
      }),
      filterGroups () { return this.groups },
      filterReiPermissions () { return this.permissions.filter(val => val.modulo === 'rei') },
    },
    watch: {
      todasPermissoesRei (value) {
        this.selecionarPermissoes(this.filterReiPermissions, value)
      },
      groups () {
        if (this.propWizard) this.$emit('changed', this.groups)
      }
    },
    beforeMount () {
      this.getGroups()
    },
    methods: {
      selecionarPermissoes (permissions, selectAll) {
        permissions.forEach(({permission_id}) => {
          let wasAdded = this.listPermissions.includes(permission_id)

          if (selectAll && !wasAdded) {

            this.listPermissions.push(permission_id)
          } else if (!selectAll && wasAdded) {

            this.listPermissions = this.listPermissions.filter((perm) => perm.permission_id === permission_id)
          }

        })

        return permissions
      },
      async getGroups () {
        loader({ text: 'Obtendo dados...', active: true })

        try {
          await AccessGroupsService.indexAcessGroups().then(res => this.groups = res)
          await AccessGroupsService.indexPermissions().then(res => this.permissions = res)

          loader({ text: '', active: false })
        } catch (e) {
          this.errorApi(e)
        }
      },
      clearEdit () {
        this.editObj = {}
        this.nomeDoGrupo = ''
        this.listPermissions = []
      },
      activeOrInactiveGroup (val) {
        AccessGroupsService.updateStatus(val.group_id, { ativo: (val.ativo !== 1) }).then(res => {
          this.finishActions(`Grupo ${(val.ativo !== 1) ? 'desativado' : 'ativado'}`)
          this.getGroups()
          this.verifyGroup(val)
        }).catch(e => this.errorApi(e))
      },
      openEditGroup (val) {
        this.editObj = { ...val }
        this.nomeDoGrupo = val.name

        loader({ text: 'informando dados', active: false })

        AccessGroupsService.getAcessGroup(val.group_id).then(res => {
          this.editObj = { ...res }

          if (res.permissions.length) {
            res.permissions.forEach(val => this.listPermissions.push(val.permission_id))
          }

          this.$root.$emit('bv::show::modal', 'modalAddGroup')
        }).finally(loader({ text: '', active: false }))
      },
      deleteGroup (val) {
        objSwal.question.title = ''
        objSwal.question.text = 'Confirma a exclusão deste grupo?'

        return Swal.fire (objSwal.question).then(result => {
          if (result.value) {
            AccessGroupsService.deleteAcessGroup(val.group_id).then(res => {
              this.finishActions('Grupo excluído com sucesso')
              this.getGroups()
              this.verifyGroup(val)
            }).catch(e => this.errorApi(e))
          }
        })
      },
      addOrEditGroup () {
        let check = Object.keys(this.editObj)
        let obj = { name: this.nomeDoGrupo, permissions: this.listPermissions }

        loader({ text: `${check.length ? 'Editando' : 'Cadastrando'} grupo de acesso`, active: true })

        if (!check.length) {
          AccessGroupsService.storeAcessGroups(obj).then(res => {
            this.finishActions('')
            this.getGroups()
          }).catch(error => this.errorApi(error))
        } else {
          AccessGroupsService.updateAcessGroup(this.editObj.group_id, obj).then(res => {
            this.verifyGroup(this.editObj)
            this.finishActions('')
            this.getGroups()
          }).catch(error => this.errorApi(error))
        }
      },
      finishActions (message) {
        objSwal.success.title = 'Etapa finalizada!'
        objSwal.success.text = message

        this.clearEdit()
        this.$root.$emit('bv::hide::modal', 'modalAddGroup')
        loader({ text: '', active: false })
        return Swal.fire(objSwal.success)
      },
      errorApi (error) {
        this.$root.$emit('bv::hide::modal', 'modalAddGroup')
        loader({ text: '', active: false })

        const message = getErrors(error)

        return displayMessage('error', 'Erro!', message.message)
      },
      verifyGroup (group) {
        const atualizado = this.user.groups.find(grupo => grupo.group_id === group.group_id)

        if (atualizado) this.$store.dispatch('auth/check', this.token)
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/_exports';

  .headerTitle {
    @extend %titleBox--sm;
    background-color: $color-gray-light;
    margin-top: pxToRem(-16);
  }

  .acessGroupTable {
     thead th {
      &:first-child {
        width: pxToRem(112);
      }

      &:last-child {
        width: pxToRem(160);
      }
    }

    tbody td {
      border-left: none;
      border-right: none;
    }
  }

  .CadastrarServentia-border {
    .customNavModal {
      &.nav {
        border-bottom-color: $color-gray-light !important;
      }
    }
  }

  .customNavModal {
    &_link {
      & > .nav-link {
        border-radius: pxToRem(6) pxToRem(6) 0 0;

        &.active {
          color: $color-black;
          font-weight: 600;
        }

        &:not(.active),
        &:not(.active):hover {
          border: solid pxToRem(1);
          border-color:  rgba($color-gray, .4)  rgba($color-gray, .4) transparent  rgba($color-gray, .4);
        }
      }
    }
  }

  .tabModalActive {
    margin-bottom: pxToRem(2);
  }
</style>
